export const navLinks = [
  { label: '公共区', href: '#public-area' },
  { label: '吃瓜大本营', href: '#campus' },
  { label: '讨论群', href: '#lounge' },
  { label: '粉丝团', href: '#fanclub' },
  { label: '热评榜', href: '#ranking' },
];

export const heroStats = [
  { value: '3,482', label: '在线老哥' },
  { value: '128', label: '今日新料' },
  { value: '46', label: '讨论群' },
  { value: '9.8w', label: '累计热评' },
];

export const tickerItems = [
  '20:14 老哥_扒细节 把三段返图时间轴对齐了，顺序对不上',
  '20:11 瓜田守望者 蹲一个高清版本，糊图看不清字',
  '20:09 深夜冲浪 楼上的对照表我先存了，感谢整理',
  '20:06 前排小板凳 热评第二条分析得挺细，建议看',
  '20:02 吃瓜不讲价 有新料记得 @我，先去补前情',
  '19:58 细节控老陈 服化道改动点我做了表格，评论区自取',
  '19:55 粉丝团小队长 蹲新料的兄弟姐妹们排队打卡',
];

export const topicTags = [
  { label: '#舞台返图', size: 'lg', tone: 'primary' },
  { label: '#时间线复盘', size: 'lg', tone: 'accent' },
  { label: '#剪辑顺序', size: 'md', tone: 'secondary' },
  { label: '#服化道改动', size: 'md', tone: 'primary' },
  { label: '#收音波形', size: 'sm', tone: 'secondary' },
  { label: '#联名暗号', size: 'md', tone: 'accent' },
  { label: '#热评考古', size: 'sm', tone: 'primary' },
  { label: '#蹲新料', size: 'lg', tone: 'secondary' },
  { label: '#老哥开聊', size: 'md', tone: 'primary' },
  { label: '#粉丝团整理', size: 'sm', tone: 'accent' },
  { label: '#逐帧对比', size: 'md', tone: 'secondary' },
  { label: '#背景板细节', size: 'sm', tone: 'primary' },
  { label: '#路透视角', size: 'md', tone: 'accent' },
  { label: '#热评接力', size: 'sm', tone: 'secondary' },
  { label: '#公共区今日榜', size: 'lg', tone: 'primary' },
];

export const featuredPosts = [
  {
    id: 1,
    category: '舞台返图',
    title: '深夜彩排返图流出，舞台灯光改动细节被逐帧对比',
    excerpt: '老哥把三个角度的返图叠在一起，发现主灯位换了方向，连地屏图案都重新排过。',
    author: '老哥_扒细节',
    time: '12 分钟前',
    heat: '2.4w',
    comments: '386',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20rehearsal%20photo%20with%20warm%20crimson%20and%20gold%20stage%20lights%2C%20silhouette%20of%20lighting%20rig%20and%20LED%20floor%20pattern%2C%20cinematic%20moody%20atmosphere%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography%2C%20rich%20warm%20tones&width=800&height=560&seq=hlws-post-01&orientation=landscape',
  },
  {
    id: 2,
    category: '剪辑顺序',
    title: '综艺番外播放顺序对不上，逐帧对比后真相浮出水面',
    excerpt: '有老哥把两版片源同步播放，发现插叙段落被调换，连字幕时间码都错位了三秒。',
    author: '前排小板凳',
    time: '38 分钟前',
    heat: '1.9w',
    comments: '274',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20video%20editing%20timeline%20on%20large%20monitor%20screen%20in%20dim%20warm%20studio%2C%20glowing%20crimson%20and%20amber%20waveforms%2C%20frames%20lined%20up%20for%20comparison%2C%20cinematic%20technical%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20warm%20color%20palette&width=800&height=560&seq=hlws-post-02&orientation=landscape',
  },
  {
    id: 3,
    category: '时间线复盘',
    title: '音乐节后台时间线被整理成对照表，粉丝团人手一份',
    excerpt: '从入场到返场，每一段时间都有对应画面佐证，整理得比官方通告还清楚。',
    author: '粉丝团小队长',
    time: '1 小时前',
    heat: '1.6w',
    comments: '198',
    image: 'https://readdy.ai/api/search-image?query=Backstage%20festival%20corridor%20lit%20by%20warm%20amber%20lanterns%2C%20flight%20case%20and%20cable%20coils%2C%20handwritten%20schedule%20boards%20blurred%20in%20background%2C%20cinematic%20documentary%20style%2C%20crimson%20accents%2C%20no%20faces%2C%20no%20readable%20text&width=800&height=560&seq=hlws-post-03&orientation=landscape',
  },
  {
    id: 4,
    category: '服化道改动',
    title: '剧组定妆照路透，服化道改动点被做成全记录',
    excerpt: '配色、纹样、配饰位置全都对了一遍，连腰带的扣法都跟前作不一样。',
    author: '细节控老陈',
    time: '2 小时前',
    heat: '1.3w',
    comments: '152',
    image: 'https://readdy.ai/api/search-image?query=Costume%20and%20wardrobe%20detail%20flatlay%20on%20warm%20linen%20surface%2C%20folded%20crimson%20and%20gold%20embroidered%20fabrics%2C%20brass%20accessories%20and%20sketch%20cards%2C%20soft%20natural%20window%20light%2C%20editorial%20craft%20photography%2C%20no%20faces&width=800&height=560&seq=hlws-post-04&orientation=landscape',
  },
  {
    id: 5,
    category: '收音波形',
    title: '直播设备收音门再添新料，音频波形对比图来了',
    excerpt: '两段音轨拉到同一条时间轴上，底噪曲线几乎完全重合，评论区开始逐秒数。',
    author: '深夜冲浪',
    time: '3 小时前',
    heat: '1.1w',
    comments: '129',
    image: 'https://readdy.ai/api/search-image?query=Audio%20waveform%20graph%20glowing%20amber%20and%20crimson%20on%20dark%20studio%20console%2C%20microphone%20and%20headphones%20in%20soft%20focus%2C%20technical%20cinematic%20aesthetic%2C%20warm%20high%20contrast%20lighting%2C%20no%20text%2C%20no%20faces&width=800&height=560&seq=hlws-post-05&orientation=landscape',
  },
  {
    id: 6,
    category: '联名暗号',
    title: '品牌联名预热海报配色暗号，被粉丝团一秒猜中',
    excerpt: '主视觉里那抹金红不是随便选的，对照过往三季限定色卡，答案呼之欲出。',
    author: '瓜田守望者',
    time: '4 小时前',
    heat: '9,860',
    comments: '97',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20fashion%20collaboration%20poster%20texture%20with%20bold%20crimson%20and%20gold%20graphic%20shapes%2C%20torn%20paper%20layers%20and%20halftone%20grain%2C%20studio%20product%20lighting%2C%20no%20text%2C%20no%20logos%2C%20no%20faces%2C%20editorial%20design%20aesthetic&width=800&height=560&seq=hlws-post-06&orientation=landscape',
  },
];

export const chatMessages = [
  { user: '老哥_扒细节', time: '20:14', text: '刚把三段素材沿时间轴对齐了，顺序确实对不上，第二段被挪到前面了。' },
  { user: '瓜田守望者', time: '20:12', text: '蹲一个高清返图，糊成那样根本看不清背景板上的字。' },
  { user: '深夜冲浪', time: '20:09', text: '楼上的对照表我先存了，整理得比官方通告还齐，感谢老哥。' },
  { user: '前排小板凳', time: '20:06', text: '热评第二条分析得挺细，建议新来的先看那条再开麦。' },
  { user: '细节控老陈', time: '20:03', text: '服化道改动点我做了表格，腰扣位置跟前作差了一个扣眼。' },
  { user: '粉丝团小队长', time: '19:58', text: '蹲新料的兄弟姐妹们排队打卡，今晚还有一波新料要放。' },
];

export const discussionGroups = [
  { name: '公共区大群', desc: '什么都能聊，人多热闹', online: '1,286', tag: '综合' },
  { name: '时间线复盘组', desc: '只聊细节，禁止灌水', online: '642', tag: '深度' },
  { name: '热评接龙群', desc: '抢热评、接力跟评', online: '418', tag: '互动' },
  { name: '新料蹲点群', desc: '第一时间搬运新料', online: '903', tag: '爆料' },
];

export const fanGroups = [
  { name: '舞台细节研究所', desc: '灯光、地屏、机位逐帧看', members: '12.4w 人蹲新料', icon: 'ri-focus-3-line' },
  { name: '综艺时间线复盘组', desc: '对照表整理、片源比对', members: '8.7w 人蹲新料', icon: 'ri-time-line' },
  { name: '联名暗号破译团', desc: '配色、色卡、暗号全破译', members: '3.2w 人蹲新料', icon: 'ri-key-2-line' },
  { name: '热评考古队', desc: '把经典热评一条条翻出来', members: '5.5w 人蹲新料', icon: 'ri-archive-line' },
];

export const rankingList = [
  { rank: 1, title: '三段返图叠图对比：主灯位到底换了没', author: '老哥_扒细节', heat: '2.4w', percent: 96 },
  { rank: 2, title: '这篇复盘把时间线讲明白了，新手先看这个', author: '深夜冲浪', heat: '1.9w', percent: 84 },
  { rank: 3, title: '服化道改动全记录，腰扣差了一个扣眼', author: '细节控老陈', heat: '1.5w', percent: 71 },
  { rank: 4, title: '音频波形对比图，底噪曲线几乎重合', author: '前排小板凳', heat: '1.2w', percent: 63 },
  { rank: 5, title: '联名海报那抹金红，对上了三季限定色卡', author: '瓜田守望者', heat: '9,860', percent: 52 },
  { rank: 6, title: '热评接力：一句话总结今晚的新料', author: '吃瓜不讲价', heat: '8,140', percent: 44 },
  { rank: 7, title: '蹲新料打卡帖，今晚还有一波在路上', author: '粉丝团小队长', heat: '6,720', percent: 36 },
];

export const footerColumns = [
  {
    title: '逛公共区',
    items: ['今日话题墙', '吃瓜大本营', '热评榜', '蹲新料打卡'],
  },
  {
    title: '找同好',
    items: ['讨论群导航', '粉丝团入驻', '老哥开聊', '细节复盘组'],
  },
  {
    title: '关于本站',
    items: ['站内规则', '社区公约', '内容说明', '联系运营'],
  },
];